import React, { useMemo, useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { archetypes, archetypeOrder } from '../data/archetypes';
import StarField from '../components/StarField';
import RadarChart from '../components/RadarChart';
import styles from './RadarResult.module.css';

export default function RadarResult() {
  const { state, dispatch } = useApp();
  const [phase, setPhase] = useState(0);

  const { primary, secondary, all } = useMemo(() => {
    const sorted = Object.entries(state.scores).sort((a, b) => b[1] - a[1]);
    const primary = sorted[0] ? archetypes[sorted[0][0]] : archetypes.jester;
    const secondary = sorted[1] ? archetypes[sorted[1][0]] : null;
    const all = archetypeOrder.map(key => ({
      key,
      ...archetypes[key],
      score: state.scores[key] || 0,
    }));
    return { primary, secondary, all };
  }, [state.scores]);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 300),
      setTimeout(() => setPhase(2), 1000),
      setTimeout(() => setPhase(3), 1800),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  const handleContinue = () => {
    if (phase < 2) return;
    setPhase(4);
    setTimeout(() => dispatch({ type: 'SET_PAGE', payload: 'result' }), 800);
  };

  return (
    <div 
      className={`${styles.container} ${phase >= 4 ? styles.fadeOut : ''}`} 
    >
      <StarField density={80} speed={0.15} />
      
      <div className={styles.layout}>
        {/* 左侧文字信息 */}
        <div className={`${styles.leftPanel} ${phase >= 1 ? styles.visible : ''}`}>
          <div className={styles.label}>原型分析完成</div>
          <h1 className={styles.title}>你的星图已生成</h1>
          
          <div className={`${styles.resultInfo} ${phase >= 2 ? styles.visible : ''}`}>
            <div className={styles.primaryResult}>
              <span className={styles.resultLabel}>主导原型</span>
              <span className={styles.resultValue}>{primary.name}</span>
              <span className={styles.planetName}>{primary.planet}</span>
            </div>
            
            {secondary && (
              <div className={styles.secondaryResult}>
                <span className={styles.resultLabel}>次要原型</span>
                <span className={styles.resultValue}>{secondary.name}</span>
              </div>
            )}
          </div>
          
          {phase >= 3 && (
            <button className={styles.continueBtn} onClick={handleContinue}>
              查看详细结果 →
            </button>
          )}
        </div>
        
        {/* 右侧雷达图 */}
        <div className={`${styles.rightPanel} ${phase >= 1 ? styles.visible : ''}`}>
          <div className={styles.chartWrapper}>
            <RadarChart data={all} size={500} />
          </div>
        </div>
      </div>
    </div>
  );
}
